module.exports = __webpack_public_path__ + "img/img_5.48ca71cd.png";